import $$ from 'cmn-utils'

const baseUrl = "/api/linkage/super/";
export default {
    create: (params) => {
        return $$.post(baseUrl + 'create', params)
    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
    get: (params) => {
        return $$.get(baseUrl + 'get', params)
    },
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
    changeState: (params) => {
        return $$.post(baseUrl + 'update-state', params)
    },
    update: (params) => {
        return $$.post(baseUrl + 'update', params)
    },
    updateEnable: (params) => {
        return $$.post(baseUrl + 'update-enable', params)
    },

}